import React from 'react';
import { motion } from 'framer-motion';
import { BookOpen } from 'lucide-react';
export function Modules() {
  const modules = ['Introducción al microcemento', 'Materiales', 'Herramientas', 'Preparación de superficies', 'Aplicación paso a paso', 'Terminaciones', 'Presupuestos', 'Cómo conseguir clientes', 'Errores comunes', 'Escalado'];
  return <section className="py-12 md:py-16 px-4 bg-brand-gray border-t border-white/5" data-id="element-148">
      <div className="max-w-5xl mx-auto" data-id="element-149">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-10" data-id="element-150">
          <h2 className="text-4xl md:text-6xl text-white" data-id="element-151">
            EL SISTEMA COMPLETO.{' '}
            <span className="text-brand-yellow" data-id="element-152">NO UN CURSO GENÉRICO.</span>
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-153">
          {modules.map((mod, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.05
        }} className="bg-brand-dark border border-white/10 p-6 rounded-2xl flex items-center gap-6 hover:border-brand-yellow/30 transition-colors" data-id="element-154">
              <div className="bg-brand-yellow/10 p-4 rounded-xl flex-shrink-0" data-id="element-155">
                <BookOpen className="text-brand-yellow w-6 h-6" data-id="element-156" />
              </div>
              <div data-id="element-157">
                <div className="text-brand-yellow font-bold text-sm tracking-widest uppercase mb-1" data-id="element-158">
                  Módulo {i + 1}
                </div>
                <h4 className="text-xl text-white font-bold" data-id="element-159">{mod}</h4>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}